<template>
	<div>
		<base-header class="pb-6 bg-light">
			<b-row align-v="center" class="py-4">
				<b-col cols="12" lg="6">
					<h6 class="h2 d-inline-block mb-0 text-dark">OTA Import</h6>
				</b-col>
				<b-col cols="12" lg="6" class="text-right">
					<nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
						<route-bread-crumb></route-bread-crumb>
					</nav>
				</b-col>
			</b-row>

			<div v-if="noAccess">
				<b-card>
					<b-card-header>
						<p class="h2 mb-2">
							<b-icon-exclamation-triangle-fill variant="danger"></b-icon-exclamation-triangle-fill
							>&nbsp;Restricted
						</p>
					</b-card-header>
					<b-card-body>Access is Restricted</b-card-body>
				</b-card>
			</div>

			<div v-else>

				<!-- Card stats -->
				<b-row>
					<b-col xl="12">
						<b-card no-body>
							<b-card-body>

								<div>
									The first line of the import file must contain the names of the fields and which
									order
									they appear. See below for the valid field names.
								</div>

								<div class="text-sm text-info">
									<br>
									<em>* NOTE: Setting [vendor,kic,kid] will set default override values for all
										rows.</em>
								</div>

								<b-row class="mb-4 mt-4">

									<b-col lg="5">
										<div class="input-group">
											<b-input-group>
												<template #prepend>
													<b-input-group-text :style="ps">Carrier *</b-input-group-text>
												</template>
												<b-form-select
													id="vendor"
													v-model="carrier"
													:options="carrier_options"
													:state="carrierValidation"
													v-on:change="loadPreviewData"
													class="importButton"
												>
												</b-form-select>
											</b-input-group>
										</div>

										<div class="input-group">
											<b-input-group>
												<template #prepend>
													<b-input-group-text :style="ps">Vendor *</b-input-group-text>
												</template>
												<b-form-select
													id="vendor"
													v-model="vendor"
													:options="vendor_options"
													:state="vendorValidation"
													v-on:change="loadPreviewData"
													class="importButton"
												>
												</b-form-select>
											</b-input-group>
										</div>

										<div class="input-group">
											<b-input-group>
												<template #prepend>
													<b-input-group-text :style="ps">KIC *</b-input-group-text>
												</template>
												<b-form-input
													id="kic"
													type="text"
													size="md"
													v-model="kic"
													:state="kicValidation"
													v-on:change="loadPreviewData"
													class="importButton"
												>
												</b-form-input>
											</b-input-group>
										</div>

										<div class="input-group">
											<b-input-group>
												<template #prepend>
													<b-input-group-text :style="ps">KID *</b-input-group-text>
												</template>
												<b-form-input
													id="kid"
													type="text"
													size="md"
													class="mt-1"
													v-model="kid"
													:state="kidValidation"
													v-on:change="loadPreviewData"
												>
												</b-form-input>
											</b-input-group>
										</div>

										<div class="input-group importFileGroup mb-3">
											<b-input-group>
												<template #prepend>
													<b-input-group-text :style="ps">Import File</b-input-group-text>
												</template>
												<b-form-file
													legend="Import File"
													id="simFileImport"
													v-model="importFile"
													placeholder="Choose a file or drop it here...(.csv,.xls,.xlsx)"
													drop-placeholder="Drop file here..."
													accept=".csv,.xls,.xlsx"
													class="browser-button mt-2 ml-2"
													@change="onLoadFileData($event)"
													:state="importFileValidation"
													plain>
												</b-form-file>
											</b-input-group>
										</div>

										<div>
											NOTE: if you do not have a KIC or KID is likely that you should use the
											defaults for DCC.
											<pre>
                      KIC 17A3F3410FB00DEEE9D0E767A10DCBC6
                      KID 65D8E0BA794E7EBC981A7FA5E886A9D7
                      Vendor for PSIM is usually Default.
                      </pre>
										</div>


									</b-col>

									<b-col lg="7">

										<vue-json-to-csv
											:json-data="template_data"
											csv-title="ota_upload_template.csv">
											<base-button type="info" title="Download a CSV template example">
												Download <i class="fa fa-download" aria-hidden="true"></i>
											</base-button>
										</vue-json-to-csv>
										&nbsp;
										<base-button type="danger" title="Upload your data to the server"
													 :disabled="invalidData"
													 v-on:click="processBatchImport">
											Upload <i class="fa fa-upload" aria-hidden="true"></i>
										</base-button>
									</b-col>

								</b-row>

								<!-- Data PREVIEW-->
								<b-row v-if="showPreviewData">
									<b-col xl="12">
										<h4>Preview of import data:</h4>
										<div class="table-responsive">
											<b-table
												class="primary-table"
												head-row-variant="primary-table"
												id="previewTable"
												sticky-header="true"
												:items="preview_items"
												show-empty
												striped
												hover
												:tbody-tr-class="rowClass"
											>
											</b-table>
										</div>
									</b-col>
								</b-row>

								<!-- Data import requirements:-->
								<b-row>
									<b-col xl="6">
										<h4>Data import requirements: </h4>
										<div class="table-responsive">
											<b-table
												class="primary-table"
												head-row-variant="primary-table"
												id="inventoryTable"
												sticky-header="true"
												:fields="fields"
												:items="items"
												show-empty
												striped
												hover
											>
											</b-table>
										</div>
									</b-col>
								</b-row>

							</b-card-body>
						</b-card>
					</b-col>
				</b-row>

			</div>

		</base-header>

		<!-- ota_batch_progress_bar -->
		<b-modal
			centered
			size="sm"
			id="ota_batch_progress_bar"
			title="Progress">
			<div class="text-center">
				<b-progress
					:max="totalCnt"
					show-progress
					height="2rem"
					class="w-100 mb-2">
					<b-progress-bar :value="currentCnt">
						<span><strong>{{ currentCnt }} of {{ totalCnt }}</strong></span>
					</b-progress-bar>
				</b-progress>
			</div>
			<div class="text-center">
				<small class="text-center">Processing ICCID: {{ iccid }}</small>
			</div>
			<template #modal-footer>
				<small class="text-center">{{ currentStatus }}</small>
			</template>
		</b-modal>

		<!-- ota_batch_progress_report -->
		<b-modal
			centered
			size="sm"
			id="ota_batch_progress_report"
			hide-footer
			header-bg-variant="info"
		>
			<template #modal-title>
				<span>Batch Import Results</span>
			</template>
			<div class="text-left mt-3">
				<p class="h4">Processed Total: {{ totalCnt }}</p>
			</div>
			<div class="text-left mt-3">
				<p class="h4">{{ success.length }} <span class="text-success">Successful</span></p>
			</div>
			<div class="text-left">
				<p class="h4">{{ errors.length }} <span class="text-danger">Failed</span></p>
			</div>
			<div class="text-left">
				<p class="h5">
					Please
					<vue-json-to-csv :json-data="reportData" :csv-title="processTitle">
						<span class="text-primary cursor-pointer">click here</span>
					</vue-json-to-csv>
					to download a detailed list of processed SIMs.
				</p>
				<p class="h5">File Name :
					<vue-json-to-csv :json-data="reportData" :csv-title="processTitle">
						<span class="text-primary cursor-pointer">{{ processTitle + ".csv" }}</span>
					</vue-json-to-csv>
				</p>

			</div>
		</b-modal>

	</div>
</template>

<script>
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import otaDashboardService from "@/common/api-services/ota-dashboard-service";
import * as XLSX from "xlsx";
import moment from "moment";
import VueJsonToCsv from "vue-json-to-csv";
import commonService from "@/common/api-services/common";
import initService from "@/common/api-services/init-service";

export default {
	name: "otaBatch",
	components: {RouteBreadCrumb, VueJsonToCsv},
	data() {
		return {
			showPreviewData: false,
			preview_items: [],
			ps: "background-color: rgba(94,114,228) !important;color: #FFFFFF !important;",
			currentCnt: 0,
			totalCnt: 0,
			currentStatus: "",

			file: File,
			arrayBuffer: null,
			filelist: null,
			importFile: null,

			template_data: [{
				"ICCID": "99999999999999999999",
				"MSISDN": "12223334444",
				"MDN": "2223334444",
				"MIN": "2223334444",
				"EPRL": "TEST_EPRL",
				"OPLMN": "TEST_OPLMN",
				"FPLMN": "TEST_FPLMN",
				"TLS": "D0E0F8F34987491BB7DF4FF042FAB3A0D0E0F8F34987491BB7DF4FF042FAB3A0",
				"KIC": "999999410FB00DEEE9D0E767A10DCBC6",
				"KID": "999999410FB00DEEE9D0E767A10DCBC6",
				"VENDOR": "ESIM",
			}],

			actionOption: [{value: "active", text: "Activate OTA"}],
			fields: [
				{key: "name", label: "Name"},
				{key: "description", label: "Description"},
			],
			items: [
				{name: "ICCID", description: "REQUIRED: ICCID to provision"},
				{name: "MSISDN", description: "OPTIONAL: MSISDN of SIM (GSM)"},
				{name: "MDN", description: "OPTIONAL: MDN of SIM (CDMA)"},
				{name: "MIN", description: "OPTIONAL: MIN of SIM (CDMA)"},
				{name: "EPRL", description: "OPTIONAL: Name of eEPRL of SIM"},
				{name: "OPLMN", description: "OPTIONAL: Name of the OPLMN"},
				{name: "FPLMN", description: "OPTIONAL: Name of the FPLMN"},
				{name: "TLS", description: "REQUIRED: TLS key"},
				{name: "KIC", description: "REQUIRED: KIC key"},
				{name: "KID", description: "REQUIRED: KID key"},
				{
					name: "VENDOR",
					description:
						"REQUIRED: Vendor of SIM [default, gemalto, simulity, simulitylte, esim, unitedesim]",
				},
			],
			simImportRow: [],
			carrier: "",
			carrier_options: [],
			vendor: "",
			kic: "",
			kid: "",
			iccid: "",
			importData: [],
			importDataLength: 0,
			success: [],
			errors: [],
			progressStartValue: 5,
			onProgress: false,
			processTitle: "",
			reportData: [],
			vendor_options: [
				{value: "", text: "Not Set"},
				// {value: "default", text: "Default (Simulity)"},
				// {value: "gemalto", text: "Gemalto"},
				// {value: "simulity", text: "Simulity"},
				// {value: "simulitylte", text: "Simulity LTE"},
				// {value: "esim", text: "ESIM"},
				// {value: "unitedesim", text: "United Esim"},
				// {value: "execulinknsim", text: "Execulink NSIM"},
			],
			invalidData: true,
		};
	},
	computed: {
		noAccess() {
			// Determine access based on menu link configuration
			let userRoles = initService.getUserRoles();
			let link = this.$store.getters["getLinkByLink"](this.$router.currentRoute.path);

			if (!link) {
				return true;
			} else {
				userRoles = userRoles.filter(role => link.roles.includes(role.toUpperCase()));
				return userRoles.length === 0;
			}
		},
		importFileValidation() {
			return this.importFile !== null;
		},

		carrierValidation() {
			return (this.carrier !== "" || commonService.validateData("carrier", this.carrier));
		},

		vendorValidation() {
			return true;
			// return (this.vendor === "" || commonService.validateData('vendor', this.vendor));
		},

		kicValidation() {
			return (this.kic === "" || commonService.validateData("kic", this.kic));
		},

		kidValidation() {
			return (this.kid === "" || commonService.validateData("kid", this.kid));
		},
	},
	mounted() {
		document.title = "ota - Batch Loader";

		//don't do anything unless the user has access
		if (this.noAccess) {
			this.$router.push("/restricted").catch(() => {});
		}

		this.processTitle = moment(new Date()).format("YYYY-MM-DD") + "_processed";
		this.getCarriers();
		this.getVendors();
	},
	methods: {

		rowClass(item, type) {
			if (!item) return;
			if (type !== "row") return "table-info";
			if (JSON.stringify(item).includes("INVALID")) return "table-danger";
			return;
		},

		async getCarriers() {
			this.carrier_options = [];
			this.carrier_options.push({value: "", text: "Not Set"});
			await otaDashboardService.getCarriersList("").then(res => {
				res.data.result.carriers.forEach(item => {
					if (item.name !== "")
						this.carrier_options.push({value: item.name, text: item.display_name});
				});
			});
		},

		async getVendors() {
			this.vendor_options = [];
			this.vendor_options.push({value: "", text: "Not Set"});
			await otaDashboardService.getVendors().then(res => {
				// console.log('vendors:', res.data);
				if (res.data.error_string) {
					this.$toast.error(res.data.error_string);
					return;
				}
				res.data.result.forEach(item => {
					if (item.display_name.toLowerCase() !== "default") {
						this.vendor_options.push({value: item.name, text: item.display_name});
					} else {
						this.vendor_options.push({value: "default", text: `Default (${item.name})`});
					}
				});
			});
		},

		async loadPreviewData() {
			this.showPreviewData = true;
			this.preview_items = [];
			let data = this.importData;//.slice(0, 3);
			Object.keys(data).forEach(idx => {
				this.formatDataRow(data[idx]).then(row => {
					this.preview_items.push(row[0]);

					//now check the iccid to see if the carrier/vendor matches the iccid
					if (this.preview_items.length === 1 && this.preview_items[0]["iccid"]) {
						let iccid = this.preview_items[0]["iccid"];
						console.log("iccid:" + iccid);
						otaDashboardService.inventory_check(iccid).then(res => {
							console.warn(res);
							let message = "Unable to validate iccid range. Proceed with caution.";
							if (!res.data.error_string && res.data.result.carrier) {
								this.carrier = res.data.result.carrier;
								this.vendor = res.data.result.vendor;
								message = `Found carrier: ${this.carrier} vendor: ${this.vendor}`;
								this.$toast(message, {type: "success"});
								this.invalidData=false;
							} else {
								this.invalidData=true;
								if (res.data.error_string) message = res.data.error_string;
								this.$toast(message, {type: "error"});
							}
						});
					}

				});
			});

			//check invalid data
			if (JSON.stringify(this.preview_items).includes("INVALID")) {
				this.invalidData=true;
				let message = "NOTICE: The import identified ERRORS in the data.  Please review below.";
				this.$toast(message, {type: "error"});
			}

		},

		//validate file format and headers
		onLoadFileData(event) {
			this.file = event.target.files[0];
			if (this.file) {
				let fileReader = new FileReader();
				fileReader.readAsArrayBuffer(this.file);
				fileReader.onload = e => {
					this.arrayBuffer = fileReader.result;
					let data = new Uint8Array(this.arrayBuffer);
					let arr = new Array();
					for (let i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
					let bstr = arr.join("");
					let wb = XLSX.read(bstr, {type: "binary"});
					let first_sheet_name = wb.SheetNames[0];
					let ws = wb.Sheets[first_sheet_name];
					let arraylist = XLSX.utils.sheet_to_json(ws, {raw: false});
					this.importData = arraylist;
					this.importDataLength = arraylist.length;
					this.loadPreviewData();
				};
			} else {
				this.showPreviewData = false;
			}
		},

		async formatDataRow(data_in) {
			let data_out = [];
			//format data to lowercase
			data_in = commonService.OtaMapImportKeys(data_in);
			//validate each field
			Object.keys(data_in).forEach(field => {
				//add forced defaults
				if (this.vendor !== "" && field === "vendor") data_in[field] = this.vendor;
				if (this.kic !== "" && field === "kic") data_in[field] = this.kic;
				if (this.kid !== "" && field === "kid") data_in[field] = this.kid;
				// run validator
				if (!commonService.validateData(field, data_in[field])) {
					data_in[field] = "!!INVALID!!" + data_in[field];
				}
			});
			// add to output array
			data_out.push(data_in);
			return data_out;
		},

		async processBatchImport() {
			if (!this.importFileValidation || !this.vendorValidation) {
				return false;
			}

			//clear last import
			this.success = [];
			this.errors = [];
			this.reportData = [];

			this.$bvModal.show("ota_batch_progress_bar");
			this.onProgress = true;
			this.progressStartValue = 5;
			this.setProgressTimer();

			//console.log(JSON.stringify(this.importData));

			for (let i = 0; i < this.importData.length; i++) {

				this.currentCnt = (i + 1);
				this.totalCnt = this.importDataLength;


				try {

					//console.log('row'+i,this.importData[i]);

					let row = await this.formatDataRow(this.importData[i]);
					//console.log("row:",row);

					//format the data row (lowercase keys)
					//let row = commonService.ConvertKeysToLowerCase(this.importData[i]);
					row = commonService.ConvertKeysToLowerCase(row[0]);
					//console.log("row3:",row);
					this.iccid = row["iccid"];
					//console.log("iccid:",this.iccid);

          if (!this.iccid && !commonService.validateData('iccid', this.iccid)) {
            this.errors.push(i + ':' + this.iccid);
            this.reportData.push({
              ICCID: this.iccid,
              STATUS: "ERROR",
              DETAILS: "Invalid ICCID: " + i + ':' + this.iccid
            });
          } else {
            let data = {
              type: "ota",
              force: "1",
              method: "activate",
              vendor: this.vendor,
              carrier: this.carrier,
              items: [row]
            };
            //console.log('dataset:',JSON.stringify(data));
            //{"type":"ota","force":"1","method":"activate","vendor":"esim","items":[{"iccid":"89114900000000017503","tls":"F3BD6A75DBFAEF6844BED69635050097E30289E0C95FDBAB9CDAB587416C91A0","kic":"B2CCF1D7577D6EE607F2656299AA0D0E","kid":"F74D277017ABA54EC8312F6C8C044C3A","vendor":"esim"}]}
            //{"type":"ota","force":"1","method":"activate","vendor":"esim","items":[{"iccid":"89114900000000017503","tls":"F3BD6A75DBFAEF6844BED69635050097E30289E0C95FDBAB9CDAB587416C91A0","kic":"B2CCF1D7577D6EE607F2656299AA0D0E","kid":"F74D277017ABA54EC8312F6C8C044C3A","vendor":"esim"}]}
            await otaDashboardService.inventory_add(data).then(res => {

							if (res.data.results.length > 0 && !res.data.error_string) {
								this.currentStatus = JSON.stringify(res.data);
								this.success.push(this.iccid);
								this.reportData.push({
									ICCID: this.iccid,
									STATUS: "SUCCESS",
									DETAILS: JSON.stringify(res.data),
								});
							} else {
								this.currentStatus = JSON.stringify(res.data.error_string);
								this.errors.push(this.iccid);
								this.reportData.push({
									ICCID: this.iccid,
									STATUS: "ERROR",
									DETAILS: String(res.data.error_string || i + ": iccid missing"),
								});
							}
						});
					}

				} catch (e) {
					console.error(e);
					this.currentStatus = JSON.stringify(e.message);
					//handle error
					this.errors.push(this.iccid);
					this.reportData.push({
						ICCID: this.iccid,
						STATUS: "ERROR",
						DETAILS: e.message,
					});
				}
			}
			this.showProcessingReport();
		},

		setProgressTimer() {
			this.timer = setInterval(() => {
				this.progressStartValue = this.progressStartValue + (Math.random() * 300) / this.progressStartValue;
				if (this.progressStartValue > 100) {
					this.progressStartValue = 10;
				}
			}, 1000);
		},

		showProcessingReport() {
			setTimeout(() => {
				this.$bvModal.hide("ota_batch_progress_bar");
				this.onProgress = false;
			}, 1000);
			setTimeout(() => {
				this.$bvModal.show("ota_batch_progress_report");
			}, 1500);
		},

	},

};
</script>
